module.exports = __webpack_public_path__ + "img/baoxiu.5ba135de.png";